module.exports = __webpack_public_path__ + "media/images/social/rt-cea3c298335bd94b63e8c91801bc4586.svg";